// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__3JKhX","error-label":"LoginForm_error-label__2i0N5"};